angular.module('capability-ng-scheduler').factory('SectionBuilder', function SectionBuilder(Interface) {
  var DTD = {
    id: 'key',
    nk: 'string',
    cd: 'string',
    term: 'key',
    course: 'key',
    campus: 'key',
    seats_offered: 'integer',
    instructor_name: 'string',
    class_start_dt: {
      type: 'moment',
      typeDef: 'YYYY-MM-DD'
    },
    class_end_dt: {
      type: 'moment',
      typeDef: 'YYYY-MM-DD'
    },
    drop_start_dt: {
      type: 'moment',
      typeDef: 'YYYY-MM-DD'
    },
    drop_end_dt: {
      type: 'moment',
      typeDef: 'YYYY-MM-DD'
    },
    is_unlimited_seating: 'boolean',
    note: 'string',
    section_type: 'integer',
    _section_times: 'ngArray',
    _section_campus: 'object',
    _section_status: 'object',
    _section_info_display: 'ngObject',
    _is_selected: 'boolean',
    _course: 'object',
    _waitlist_position: 'object',
    _section_type_name: 'string'
  };

  function SectionDTO(data) {
    Interface.implement(DTD, data, this);
  }

  return SectionDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/section_builder.es.js